import { createSelector } from 'reselect'
import getExperienceItemsView from './itemViews/getExperienceItemsView'
import { isBundledExperienceItem, isExperienceItem, isLEHotelItem, isBedbankItem, isAccommodationV2Item, isVillaItem } from 'lib/checkout/checkoutUtils'

export const EXPERIENCE_INFLOW_BUNDLE_METADATA = { checkoutExperienceInflowBundle: true }

export const getExperienceInflowBundleOfferIds = createSelector(
  getExperienceItemsView,
  views => [...new Set(views.data.filter(view => view.item.metaData?.checkoutExperienceInflowBundle === true &&
    view.experience.productType !== 'transfer' && view.item.tickets.some(ticket => ticket.count > 0) &&
    !isBundledExperienceItem(view.item) && view.totals.price > 0).map(view => view.item.experienceId))],
)

export function hasValidExperienceInflowBundleMetadata(state: App.State): boolean {
  return state.checkout.cart.items.filter(isExperienceItem).every(item => {
    const marker = item.metaData?.checkoutExperienceInflowBundle
    return marker === undefined || marker === false || (marker === true && item.metaData?.checkoutExperienceUpsell !== true && !isBundledExperienceItem(item))
  })
}

export function hasExperienceInflowBundleAccommodation(state: App.State): boolean {
  return state.checkout.cart.items.some(item => isLEHotelItem(item) || isBedbankItem(item) || isAccommodationV2Item(item) || isVillaItem(item))
}

export function hasExperienceInflowBundleComposition(state: App.State): boolean {
  return hasExperienceInflowBundleAccommodation(state) && hasValidExperienceInflowBundleMetadata(state) && getExperienceInflowBundleOfferIds(state).length >= 2
}
